module.exports = __webpack_public_path__ + "media/images/faces/female/20-81acb019769ec3bf2e4ee13188dd54d4.jpg";